import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=2d779d5e&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=ts"
export * from "./AppContent.vue?vue&type=script&lang=ts"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=2d779d5e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d779d5e",
  null
  
)

export default component.exports